import { NgModule } from '@angular/core';
import { HisAuthSharedModule } from './his-auth-shared.module';

import { HisAuthGuard } from './guard/his-auth.guard';
import { HisAuthService } from './service/his-auth.service';

/**
 * CoreModule for authentication and authorization
 */
@NgModule( {
    imports: [
        HisAuthSharedModule
    ],
    declarations: [
    ],
    exports: [
        HisAuthSharedModule
    ]
} )

export class HisAuthCoreModule {
}
